import apiClient from "../utils/apiClient";
import {
  LOAD_ALL_SURVEYS_REQUEST,
  LOAD_ALL_SURVEYS_SUCCESS,
  LOAD_ALL_SURVEYS_FAIL,
  SURVEY_DETAIL_REQUEST,
  SURVEY_DETAIL_SUCCESS,
  SURVEY_DETAIL_FAIL,
  DELETE_SURVEY_REQUEST,
  DELETE_SURVEY_SUCCESS,
  DELETE_SURVEY_FAIL,
  CLEAR_ERRORS,
} from "../constants/adminSurveyConstants";

export const getSurveys = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_ALL_SURVEYS_REQUEST });
    const { data } = await apiClient.get("/admin/surveys");
    dispatch({ type: LOAD_ALL_SURVEYS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: LOAD_ALL_SURVEYS_FAIL, payload: error?.response?.data || error.message || error });
  }
};

export const getSurveyDetail = (id) => async (dispatch) => {
  try {
    dispatch({ type: SURVEY_DETAIL_REQUEST });
    const { data } = await apiClient.get(`/admin/surveys/${id}`);
    dispatch({ type: SURVEY_DETAIL_SUCCESS, payload: data?.data || data });
  } catch (error) {
    dispatch({ type: SURVEY_DETAIL_FAIL, payload: error?.response?.data?.errMessage || error.message || error });
  }
};

export const deleteSurveyData = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_SURVEY_REQUEST });
    await apiClient.delete(`/admin/surveys/${id}`);
    dispatch({ type: DELETE_SURVEY_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_SURVEY_FAIL, payload: error?.response?.data || error.message || error });
  }
};

export const clearSurveyErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
